import styled from 'styled-components';

import { flexSpaceBetween, flexStart } from '../../style/reusableStyle';

export const TitleFilterContainer = styled.div<{ $maxWidthBreakPoint: string }>`
  ${flexSpaceBetween(14)};
  margin-bottom: 20px;
  width: 100%;

  & .head-other-actions {
    display: none;
  }
  flex-wrap: wrap;

  @media (max-width: ${({ theme, $maxWidthBreakPoint }) =>
    $maxWidthBreakPoint || theme.breakpoints.lg}) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: start;

    & .title-wrapper {
      width: 100%;
      flex-wrap: wrap-reverse;
      ${flexSpaceBetween(14)};

      & .head-other-actions {
        display: inline-flex;
        justify-content: flex-end;
        flex: 1;
      }
    }
  }
`;

export const FilterWrapper = styled.div<{ $maxWidthBreakPoint: string }>`
  ${flexStart};
  gap: 16px;
  flex: 1;
  display: inline-flex;
  justify-content: flex-end;
  & .inside-filter-action-btn {
    display: inline-flex;
  }

  @media (max-width: ${({ theme, $maxWidthBreakPoint }) =>
    $maxWidthBreakPoint || theme.breakpoints.lg}) {
    flex: 1;
    width: 100%;
    & .search-input {
      flex: 1;
    }

    & .inside-filter-action-btn {
      display: none;
    }
  }
`;
